export default __webpack_public_path__ + "static/media/745-icon.6ef41093.svg";